import script from "./NoAccessModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./NoAccessModal.vue?vue&type=script&setup=true&lang=ts"

import "./NoAccessModal.vue?vue&type=style&index=0&id=5237e7e0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5237e7e0"]])

export default __exports__